// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyAsiYloish3JOEnnDohiHCJh5i5IG0Y_DE",
    authDomain: "ionic-firebase-b28fa.firebaseapp.com",
    databaseURL: "https://ionic-firebase-b28fa.firebaseio.com",
    projectId: "ionic-firebase-b28fa",
    storageBucket: "ionic-firebase-b28fa.appspot.com",
    messagingSenderId: "1003408559109",
    appId: "1:1003408559109:web:99be6cc9de4fa6ec2a606c",
    measurementId: "G-4XQLRVP860",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
